// O motivo de um "sem dado", como o servidor o manda, na frase que a tela mostra.
// Motivo novo que a tela não conhece aparece cru: melhor que sumir.
const KEYS = {
  no_conversations: 'NO_CONVERSATIONS',
  no_ai_conversations: 'NO_AI_CONVERSATIONS',
  no_handoffs: 'NO_HANDOFFS',
  no_replies: 'NO_REPLIES',
  runtime_sem_ferramentas: 'RUNTIME_WITHOUT_TOOLS',
  no_tool_calls: 'NO_TOOL_CALLS',
  load_failed: 'LOAD_FAILED',
  no_agents: 'NO_AGENTS',
  runtime: 'RUNTIME',
  no_turns: 'NO_TURNS',
  no_searches: 'NO_SEARCHES',
  no_samples: 'NO_SAMPLES',
};

export const reasonLabel = (t, code) => {
  if (!code) return '';
  return KEYS[code]
    ? t(`ATENDIMENTO_REPORTS.NO_DATA_REASON.${KEYS[code]}`)
    : code;
};
